import React, { Fragment } from 'react'
import {
    Edit,
    TextInput,
    ReferenceInput,
    SelectInput,
    NumberInput
} from 'react-admin'

import Title from '../Generic/Title'
import { CustomSimpleForm } from '../Generic'

export const ComunaEdit = ({ permissions, ...props }) => {
    if (permissions === null) {
        return null
    }
    return (
        <Fragment>
            <Title title={"Editar Comuna"} />
            <Edit {...props}>
                <CustomSimpleForm>
                    <NumberInput source="id" label="ID"  disabled={true}/>
                    <NumberInput source="code" label="Código" />
                    <TextInput source="name" label="Nombre" />
                    <ReferenceInput source="provincia" reference="provincias" label="Provincia" >
                        <SelectInput source="name" />
                    </ReferenceInput>
                    <ReferenceInput source="region" reference="regiones" label="Región" >
                        <SelectInput source="name" />
                    </ReferenceInput>
                </CustomSimpleForm>
            </Edit>
        </Fragment>
    )
};
